<template>
  <section class="forcreators" id="forcreators">
    <div class="forcreators__inner">
      <h1>FOR CREATORS</h1>
      <div>
        <h2>{{ $t("forcreators.main1") }}</h2>
        <p>{{ $t("forcreators.sub1") }}</p>
      </div>
      <div>
        <h2>{{ $t("forcreators.main2") }}</h2>
        <p>{{ $t("forcreators.sub2") }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForCreatorsComponent'
}
</script>

<style scoped>
.forcreators {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  background-color: #f5f6ff;
  padding: 120px 0 120px 0;
}

.forcreators__inner {
  width: 80vw;
  max-width: 700px;
  padding-left: 10vw;
}

h1 {
  font-size: 14px;
}

h1:after {
  content: '';
  width: 50px;
  height: 1px;
  display: inline-block;
  background-color: #e1e1e1;
  margin: 0 0 0 15px;
  -webkit-transform: translateY(-4px);
  -ms-transform: translateY(-4px);
  transform: translateY(-4px);
}

h2 {
  font-size: 32px;
  line-height: 1.4em;
  margin: 60px 0 30px 0;
  color: #434345;
}

p {
  margin: 0;
  font-weight: bold;
}
</style>